import SecondPaymentsForm from './SecondPaymentsForm';

export default SecondPaymentsForm;
